import React, { createContext, useContext, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
  

const SnackbarContext = createContext();

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};

const variantToColor = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
};

export const SnackbarProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'right',
    message: '',
    variant: 'info',
  });

  const { vertical, horizontal, open, message, variant } = state;

  const handleClick = (newState) => () => {
    setState({ ...newState, open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const showSnackbar = (newState) => {
    setState({ ...newState, open: true });
  };

  const contextValue = {
    vertical,
    horizontal,
    open,
    message,
    variant,
    handleClick,
    handleClose,
    showSnackbar,
  };

  return (
    <SnackbarContext.Provider value={contextValue}>
        {children}
        <Snackbar
            open={open} 
            autoHideDuration={6000} 
            onClose={handleClose}
            anchorOrigin={{ vertical, horizontal }}
        >
            <Alert onClose={handleClose} severity={variantToColor[variant]} sx={{ width: '100%', fontSize: '1.2em' }}>
                {message}
            </Alert>
        </Snackbar> 
    </SnackbarContext.Provider>
  );
};
